import { Alert, Button, Card, Col, DatePicker, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actions from "../../actions";
import BasicLayout from "../../components/layout/index";
import "./index.less";

const Edit = (props) => {
  const [form] = Form.useForm();
  const [isError, setError] = useState(false);
  const [isBtnActive, setIsBtnActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { setCurrentTeacherSchedule, teacher_schedule } = props;

  const scheduleId = props.match.params.schedule_id;

  useEffect(() => {
    setCurrentTeacherSchedule(scheduleId);
  }, [scheduleId, setCurrentTeacherSchedule]);

  useEffect(() => {
    setIsBtnActive(true);
  }, [teacher_schedule]);

  const defaultValues = {
    video_link: "",
    file_link: "",
    class_date: "",
  };

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  const onFinish = (values) => {
    if (!isBtnActive) {
      values.button_text = "";
      values.button_link = "";
    }

    const data = {
      ...values,
      is_active: values.is_active ? 1 : 0,
      is_btn_active: isBtnActive ? 1 : 0,
    };

    props
      .addClassNote({ schedule_id: scheduleId, ...data })
      .then((resp) => {
        if (resp.data && resp.data.status) {
          props.history.push("/admin/teacher-schedules");
        } else if (resp.err && !resp.err.status) {
          setError(true);
          setErrorMessage(resp.err.message);
        }
      })
      .catch((_err) => {
        setError(true);
        setErrorMessage("Something went wrong!");
      });
  };

  const onAlertClose = () => {
    setError(false);
  };

  return (
    <BasicLayout>
      <Row>
        <Col className="teacher-schedule-edit-container" span={12}>
          <Card className="teacher-schedule-edit-card">
            {isError && (
              <Alert
                message="Error"
                description={errorMessage}
                type="error"
                closable
                onClose={onAlertClose}
              />
            )}
            <Form
              form={form}
              size="large"
              layout="vertical"
              onFinish={onFinish}
              className="page-edit-teacher-schedule"
              initialValues={defaultValues}
            >
              <Form.Item
                name="video_link"
                label="Video Link"
                className="teacher-schedule-edit-label"
              >
                <Input
                  className="teacher-schedule-edit-input"
                  placeholder="Video Link"
                />
              </Form.Item>
              <Form.Item
                name="file_link"
                label="File Link"
                className="teacher-schedule-edit-label"
              >
                <Input
                  className="teacher-schedule-edit-input"
                  placeholder="File Link"
                />
              </Form.Item>
              <Form.Item
                name="class_date"
                label="Class Date"
                className="teacher-schedule-edit-label"
                rules={[
                  {
                    required: true,
                    message: "Please enter create date",
                  },
                ]}
              >
                <DatePicker placeholder={"Class Date"} />
              </Form.Item>
              <Button htmlType="submit" type="primary" block>
                Add Notes
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </BasicLayout>
  );
};

export default connect(
  (state) => ({
    isLoggedIn: state.isLoggedIn,
    admin: state.adminInfo,
    teacher_schedule: state.teacher_schedule,
  }),
  (dispatch) => bindActionCreators({ ...actions }, dispatch)
)(withRouter(Edit));
